import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import InvitationPage from './components/InvitationPage';
import AdminDashboard from './components/AdminDashboard';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';

const AppContainer = styled.div`
  text-align: center;
  min-height: 100vh;
  background: #f5f5f5;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Routes>
          <Route path="/" element={<InvitationPage />} />
          <Route path="/invite/:secretCode" element={<InvitationPage />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AppContainer>
    </Router>
  );
}

export default App;
